import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { CommonPageProps, NonUndefined, Socnet } from '@/types';
import DefaultLayout from '@/components/layout/DefaultLayout';
import { getCommonPageProps } from '@/api/common';
import Link from '@/components/shared/Link';
import { getSiteSettings } from '@/api/site-settings';
import Image from 'next/image';
import Button from '@/components/shared/Button';

const OfertaPage = ({ h1, ofertaContent }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
    return (
        <DefaultLayout>
            <div className="wrapper">
                <Button
                    icon={<Image src="/img/back.svg" alt="" unoptimized fill />}
                    iconReverse
                    tag={Link}
                    href="/"
                    geometryVariant="arrow"
                    className="about-page-to-main"
                >
                    На главную
                </Button>
                <div className="text-page">
                    <h1>{h1}</h1>
                    <div dangerouslySetInnerHTML={{ __html: ofertaContent }} />
                </div>
            </div>
        </DefaultLayout>
    );
};

export default OfertaPage;

type ContactsPageProps = NonUndefined<
    CommonPageProps & {
        h1: string;
        socnets: Socnet[];
        footerPhone: string;
        footerEmail: string;
        ofertaContent: string;
    }
>;

export const getServerSideProps: GetServerSideProps<ContactsPageProps> = async () => {
    const [commonPageProps, siteSettings] = await Promise.all([
        getCommonPageProps(),
        getSiteSettings({
            keys: ['oferta_content'],
        }),
    ]);

    return {
        props: {
            ...commonPageProps,
            bodyClass: 'privacy-page',
            meta: {
                ...commonPageProps.meta,
                title: 'Пользовательское соглашение',
            },
            h1: 'Пользовательское соглашение',
            socnets: commonPageProps.socnets,
            footerPhone: commonPageProps.footerPhone,
            footerEmail: commonPageProps.footerEmail,
            ofertaContent: siteSettings?.data?.oferta_content ?? '',
        } satisfies ContactsPageProps,
    };
};
